import React from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const Support = () => {
  const { t } = useTranslation()
  const isShopEnabled = process.env.REACT_APP_TOGGLE_SHOP === 'true'
  const pageName = 'SUPPORT'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('TO_SUPPORT_ME')} description="" />

      <div className="container section py-4">
        <p className="lead">{t('TO_SUPPORT_ME_DESCRIPTION')}</p>

        <hr />
        <h4>{t('TO_SUPPORT_ME_TITLE_1')}</h4>
        <p>{t('TO_SUPPORT_ME_DESCRIPTION_1')}</p>

        <hr />
        <h4>{t('TO_SUPPORT_ME_TITLE_2')}</h4>
        <p>{t('TO_SUPPORT_ME_DESCRIPTION_2')}</p>

        {isShopEnabled && (
          <>
            <hr />
            <h4>{t('TO_SUPPORT_ME_TITLE_3')}</h4>
            <p>{t('TO_SUPPORT_ME_DESCRIPTION_3')}</p>
          </>
        )}

        <hr />
        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default Support
